export const lstorage = {
  set: (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn(`Unable to store ${key} in localStorage`, e);
    }
  },
  get: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn(`Unable to read ${key} from localStorage`, e);
      return null;
    }
  },
};
